import { MoveGenerator } from '../../jscaip/AI/AI';
import { Coord } from '../../jscaip/Coord';
import { LinesOfActionMove } from './LinesOfActionMove';
import { LinesOfActionRules } from './LinesOfActionRules';
import { LinesOfActionState } from './LinesOfActionState';
export class LinesOfActionMoveGenerator extends MoveGenerator {
    getListMoves(node, _config) {
        const state = node.gameState;
        const moves = [];
        if (LinesOfActionRules.getVictory(state).isPresent()) {
            return moves;
        }
        for (let y = 0; y < LinesOfActionState.SIZE; y++) {
            for (let x = 0; x < LinesOfActionState.SIZE; x++) {
                const coord = new Coord(x, y);
                const piece = state.getPieceAt(coord);
                if (piece.isPlayer()) {
                    for (const target of LinesOfActionRules.possibleTargets(state, coord)) {
                        const move = LinesOfActionMove.from(coord, target).get();
                        moves.push(move);
                    }
                }
            }
        }
        return moves;
    }
}
